import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/withdraw'
)({
  component: () => <Outlet />,
});
